import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import AlcanceForm from '../AlcanceForm';

function AlcanceEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <AlcanceForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </AlcanceForm>
    </Edit>
  );
}

export default AlcanceEdit;
